import { Button, Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { YearMonthPopoverContent } from '@/domain/termine/components/YearMonthPicker/YearMonthPopoverContent';
import { YearMonthParams } from '@/domain/termine/type';
import { getMonthNameByDate } from '@/utils/dateFunctions/getDatesOfMonth';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function YearMonthPopoverMobile() {
  const [openPopover, setOpenPopover] = useState(false);
  const { year, month } = useParams();
  const currentMonthAndYear: YearMonthParams = { year, month };
  const monthYearName = currentMonthAndYear.year + currentMonthAndYear.month;
  return (
    <Popover open={openPopover} onOpenChange={setOpenPopover}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className="md:hover:bg-white md:active:bg-white md:data-[state=open]:bg-white">
          <span className="md:hidden flex items-center gap-1">
            <div className="font-semibold text-sm">
              {getMonthNameByDate(monthYearName)}
            </div>
            <FontAwesomeIcon
              icon={faChevronDown}
              className="text-neutrals-700 text-sm font-semibold"
            />
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="bg-white w-fit p-4" sideOffset={4}>
        <YearMonthPopoverContent
          currentMonthAndYear={{
            year: currentMonthAndYear.year,
            month: currentMonthAndYear.month,
          }}
          onSelect={() => setOpenPopover(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
